import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";

export function FormField({ label, required, error, children, half = false, third = false }) {
  const { c } = useThemeSlice();
  const gridColumn = third ? "span 1" : half ? "span 1" : "1 / -1";
  return (
    <div style={{ gridColumn, minWidth: 0 }}>
      <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: c.mid, marginBottom: 6 }}>
        {label}
        {required ? <span style={{ color: "#EF4444" }}> *</span> : null}
      </label>
      {children}
      {error ? <p style={{ margin: "4px 0 0", fontSize: 11, color: "#EF4444" }}>{error}</p> : null}
    </div>
  );
}

export function FormInput({ value, onChange, placeholder, type = "text", error }) {
  const { c, dark, accentHex: A } = useThemeSlice();
  return (
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={inputStyle(c, dark, error)}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = `${A}66`;
        e.currentTarget.style.boxShadow = `0 0 0 3px ${A}18`;
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = error ? "#EF4444" : c.cardBdr;
        e.currentTarget.style.boxShadow = "none";
      }}
    />
  );
}

export function FormSelect({ value, onChange, placeholder, options }) {
  const { c, dark, accentHex: A } = useThemeSlice();
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{ ...inputStyle(c, dark), cursor: "pointer", appearance: "none" }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = `${A}66`;
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = c.cardBdr;
      }}
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}

export function FormTextarea({ value, onChange, placeholder, rows = 3 }) {
  const { c, dark, accentHex: A } = useThemeSlice();
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      style={{ ...inputStyle(c, dark), height: "auto", padding: "10px 12px", resize: "vertical", minHeight: 88 }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = `${A}66`;
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = c.cardBdr;
      }}
    />
  );
}

function inputStyle(c, dark, error) {
  return {
    width: "100%",
    height: 40,
    borderRadius: 8,
    border: `1px solid ${error ? "#EF4444" : c.cardBdr}`,
    background: dark ? "rgba(255,255,255,0.04)" : c.card,
    color: c.text,
    padding: "0 12px",
    fontSize: 13,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
  };
}
